import React from "react";
import { ErrorMessageStyled } from "./ErrorMessageStyled";
var ErrorMessage = function (_a) {
    var message = _a.message;
    return (React.createElement(ErrorMessageStyled, { className: "error-message" },
        React.createElement("h3", null, message !== null && message !== void 0 ? message : "There was an error when loading this page.")));
};
export default ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map